import React from 'react'
import Layout from '../components/layout'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Meta from '../components/meta'
import { fetchPage } from '../lib/api'
import Image from 'next/image'
import Stamp from '../components/svg/stamp.svg'
import Wrapper from '../components/layout/grid/wrapper'
import Unmissable from '../components/unmissable'
import { Container, Grid } from '@material-ui/core'
import SeasonsTabs from '../components/tabs/seasons'
import Newsletter from '../components/newsletter'

const DiscoverMallorca = ({ data }) => {
  const { t, i18n } = useTranslation('common')
  const router = useRouter()

  return (
    <>
      {data.seoMetaData && <Meta {...data.seoMetaData} />}
      <Layout active={'inspiration'}>
        <div className={`hero mallorca`}>
          <Image
            src={data.heading_image.url}
            alt=""
            layout="fill"
            width={1903}
            height={830}
            placeholder={'blur'}
            blurDataURL={data.heading_image.formats.small.url}
          />
        </div>
        <div className={'discover-intro-wrapper'}>
          <div className="discover-intro-inner">
            <h1>
              <span className="small">{data.heading_small}</span>
              {data.heading_large}
            </h1>
            <div
              className="discover-intro"
              dangerouslySetInnerHTML={{ __html: data.intro }}
            />
            <Stamp />
          </div>
        </div>
        <div className="pt-21 pb-0">
          <div className="container">
            <div className="discover-content">
              <div className="column">
                <Image
                  src={data.map_image.url}
                  alt=""
                  layout={'responsive'}
                  width={500}
                  height={500}
                />
              </div>
              <div className="column">
                <h2>
                  <span>{data.sub_heading_small}</span>
                  {data.sub_heading_large}
                </h2>
                <div
                  dangerouslySetInnerHTML={{ __html: data.sub_section_intro }}
                />
              </div>
            </div>
          </div>
        </div>
        <Wrapper background={'white'}>
          <Unmissable data={data.unmissable} />
        </Wrapper>
        <Wrapper background={'white'} noMargin>
          <Container maxWidth={'lg'}>
            <Grid container spacing={3} justify={'center'}>
              <Grid item xs={12}>
                <h3 className={'sectionHeading centered'}>
                  <span className={'tag'}>{data.seasons[`tag`]}</span>
                  {data.seasons[`heading`]}
                </h3>
              </Grid>
            </Grid>
          </Container>
          <SeasonsTabs seasons={data.seasons} />
        </Wrapper>
        <Wrapper background={'white'} withPadding noMargin>
          <Container maxWidth={'lg'}>
            <Grid container spacing={3} justify={'center'}>
              <Grid item xs={12} sm={9}>
                <Newsletter />
              </Grid>
            </Grid>
          </Container>
        </Wrapper>
      </Layout>
    </>
  )
}
export const getServerSideProps = async ({ locale, req }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      cookie: req.headers.cookie || '',
      ...(await fetchPage({ page: 'inspiration-page', locale })),
    },
  }
}
export default DiscoverMallorca
